/**
* @NApiVersion 2.x
* @NModuleScope TargetAccount
* // Copyright (c) 2021, Oracle and/or its affiliates. All rights reserved.
* // Licensed under the Universal Permissive License v 1.0 as shown at http://oss.oracle.com/licenses/upl.
*/
define([
    'N/record',
    'N/runtime',
    'N/search',
    'N/file',
], function (
    record,
    runtime,
    search,
    file
) {
    'use strict';

    var MemberShipDirectoryModel = {

        get: function (request) {
            var self = this;
            var selectvalue = request.parameters.IndustryGroup;
            var pageSize = parseInt(request.parameters.pageSize);
            var currentpage = parseInt(request.parameters.page);

            var saveSearchName = 'customsearch_nus_member_directory';
            var columns = ['altname', 'accountnumber', 'url', 'custentity_industrygroup', 'email','custentity_companyprofile','image','custentity_uenno','custentity_membershipstatus'];
        
            var rs = search.load({
                id: saveSearchName,
                columns: columns,
              });
                          
            if (self.nullCheck(request.parameters.MembershipNumber)) {

                var defaultFilters = rs.filters;
                    defaultFilters.push(search.createFilter({
                        name: "accountnumber",
                        operator: search.Operator.IS,
                        values: request.parameters.MembershipNumber.toString()
                    }));

                rs.filters = defaultFilters;
            }

            if (self.nullCheck(request.parameters.Company)) {
                var defaultFilters1 = rs.filters;
                    defaultFilters1.push(search.createFilter({
                        name: "entityid",
                        operator: search.Operator.HASKEYWORDS,
                        values: request.parameters.Company.toString()
                    }));

                rs.filters = defaultFilters1;
            }

            if (self.nullCheck(request.parameters.UENNO)) {
                var defaultFilters2 = rs.filters;
                    defaultFilters2.push(search.createFilter({
                        name: "custentity_uenno",
                        operator: search.Operator.IS,
                        values: request.parameters.UENNO.toString()
                    }));

                rs.filters = defaultFilters2;
            }

            if (self.nullCheck(selectvalue)) {

                var defaultFilters3 = rs.filters;
                    defaultFilters3.push(search.createFilter({
                        name: "custentity_industrygroup",
                        operator: search.Operator.IS,
                        values: selectvalue
                    }));

                rs.filters = defaultFilters3;
            }
            
            var totalRecordsFound = rs.runPaged().count;
            var startIndex = (currentpage - 1) * pageSize;
            var endIndex = currentpage * pageSize;
        
            var searchResults = rs.run().getRange({
                    start: startIndex,
                    end: endIndex,
                });
        
            var mappedResults = searchResults.map(function (result) {
                var fileInternalId = result.getValue('image');
                var logoUrl = fileInternalId ? self.getImageURL(fileInternalId) : '';

                return {
                    Company: result.getValue('altname'),
                        MembershipNumber: result.getValue('accountnumber'),
                        Website: result.getValue('url'),
                        IndustryGroup: result.getText('custentity_industrygroup'),
                        email: result.getValue('email'),
                        profile: result.getValue('custentity_companyprofile'),
                        imgurl: logoUrl,
                        uenno: result.getValue('custentity_uenno'), 
                        memStatus: result.getValue('custentity_membershipstatus') ? result.getText('custentity_membershipstatus') : '',
                };
            });

            var returnListData = {
                "page": currentpage,
                "recordsPerPage": pageSize,
                "totalRecordsFound": totalRecordsFound,
                "records": mappedResults.length == 1 ? mappedResults[0] : mappedResults,
                "showMembershipNumber":request.parameters.MembershipNumber,
                "showCompany":request.parameters.Company,
                "showUENNO":request.parameters.UENNO,
                "showIndustryGroupList" : self.getIndustryGroupList(selectvalue)
            }
            return returnListData
        }

    ,	nullCheck :	function nullCheck(value)
        {
            var self=this;

            if (value != null && value != '' && value != undefined)
                return true;
            else
                return false;
        }


    ,    getImageURL: function (fileInternalId) {
            var self = this;
            try {
              // Load the file by internal ID
              var fileObj = file.load({
                id: fileInternalId
              });
      
              fileObj.isOnline = true;
              var imageURL = fileObj.url;
      
              return imageURL;
            } catch (e) {
              log.error('Error', e.message);
              return null;
            }
          }

    ,    getIndustryGroupList: function(selectvalue) {
            var self =this;
            var showIndustryGroupList = [];
            var customrecord_industrygrouplistSearchObj = search.create({
                type: "customrecord_industrygrouplist",
                filters:
                [
                   ["isinactive","is","F"]
                ],
                columns:
                [
                   search.createColumn({
                      name: "name",
                      sort: search.Sort.ASC
                   }),
                   "internalid"
                ]
             });
             
            var searchResultCount = customrecord_industrygrouplistSearchObj.runPaged().count;
                customrecord_industrygrouplistSearchObj.run().each(function(result){
                showIndustryGroupList.push({
                    internalid: result.getValue("internalid"),
                    name: result.getValue("name"),
                    isSelected: selectvalue == result.getValue("internalid") ? 'T': null
                    });
                return true;
             });

             return showIndustryGroupList;
        }

    ,    getMemberProfileDetails: function(request) {
            var self =this;
            var searchResultArr = [];
            var membershipstatusID = ['1','2','3','8','9'];
            var membershipTypeID = ['1','2','4','7','8'];

              var rs = search.create({
                type: "customer",
                filters:
                [
                   ["isperson","is","F"], 
                   "AND", 
                   ["custentity_membershiptype","anyof",membershipTypeID], 
                   "AND", 
                   ["custentity_membershipstatus","anyof",membershipstatusID],
                   "AND", 
                   ["accountnumber","is",request.parameters.membershipnumber.toString()],
                ],
                columns:
                [
                   "entityid",
                   "altname",
                   "accountnumber",
                   "custentity_industrygroup",
                   "email",
                   "url",
                   "custentity_uenno",
                   "custentity_companyprofile",
                   "image",
                   "custentity_membershiptype",
                   "custentity_membershipstatus"
                ]
             });
         
            var searchResult = rs.run();

                searchResult.each(function (result) {

                var fileInternalId = result.getValue('image');
                var logoUrl = fileInternalId ? self.getImageURL(fileInternalId):'';
                var getmemType = result.getValue('custentity_membershiptype') === "1";
                var getmemStatusID = result.getValue('custentity_membershipstatus');
                var responceMsg = '';
                    if(getmemStatusID == "2") 
                    {
                        // Exempted
                        responceMsg = 'This company is exempted from SBF Membership.';
                    }
                    else if(getmemStatusID == "1"){
                        // Active
                        // display normal message and other
                    }
                    else if(getmemStatusID == "3"){
                        // Inactive
                        responceMsg = 'This organisation is currently not a member of SBF.';
                    }
                    else if(getmemStatusID == "8"){
                        // Terminated
                        responceMsg = 'This organisation is currently not a member of SBF.';
                    }
                    else if(getmemStatusID == "9"){
                        // Ceased Membership	
                        responceMsg = 'This organisation is currently not a member of SBF.';
                    }

            var recs = {
                    Company: result.getValue('altname'),
                    MembershipNumber: result.getValue('accountnumber'),
                    Website: result.getValue('url'),
                    IndustryGroup: result.getText('custentity_industrygroup'),
                    email: result.getValue('email'),
                    profile: result.getValue('custentity_companyprofile'),
                    imgurl: logoUrl,
                    uenno: result.getValue('custentity_uenno'), 
                    memType: result.getValue('custentity_membershiptype'), 
                    memStatusID: result.getValue('custentity_membershipstatus'),
                    memStatus: result.getValue('custentity_membershipstatus') ? result.getText('custentity_membershipstatus'):'',
                    responceMsg: responceMsg,
				}
				searchResultArr.push(recs);

                return true;
            });

            var returnListData = {
                "records": searchResultArr,
                "showMembershipNumber":request.parameters.membershipnumber
            }
            return returnListData
        }
    }

    return MemberShipDirectoryModel
})
